<div class="architecture-class" ngFlowchartCanvas [ngFlowchartOptions]="options">
</div>

